export const STEP_UPLOAD_PIC_LIST = 'list';
export const STEP_UPLOAD_PIC_EDIT = 'edit';
export const STEP_UPLOAD_PIC_SELECTED = 'selected';

export const UPLOAD_TYPE_CAMERA_PHOTO = 'camera-photo';
export const UPLOAD_TYPE_UPLOADED_PIC = 'uploaded-pic';
export const UPLOAD_TYPE_FB_PIC = 'facebook-pic';
export const UPLOAD_TYPE_INSTA_PIC = 'insta-pic';
export const UPLOAD_TYPE_DEFAULT_PIC = 'default-pic';

export const allowedStrategies = [
    UPLOAD_TYPE_CAMERA_PHOTO,
    UPLOAD_TYPE_UPLOADED_PIC,
    UPLOAD_TYPE_FB_PIC,
    UPLOAD_TYPE_INSTA_PIC,
    UPLOAD_TYPE_DEFAULT_PIC,
];
